import { render, staticRenderFns } from "./update.vue?vue&type=template&id=534c75df&scoped=true"
import script from "./update.vue?vue&type=script&lang=ts"
export * from "./update.vue?vue&type=script&lang=ts"
import style0 from "./update.vue?vue&type=style&index=0&id=534c75df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c75df",
  null
  
)

export default component.exports